import React from "react";
import "../../sass/ui/label.scss";

export const Label = ({ htmlFor, children }) => (
  <label htmlFor={htmlFor} className="custom-label">{children}</label>
);
